<template>
  <div id="container">
    <div class="column">
      <multitoggle
        v-model="selectedType"
        :options="byOptions"
      />

      <template v-if="selectedType === 'user'">
        <div class="single-group">Users</div>
        <div class="master-list">
          <ul>
            <li
              v-for="user in filteredUsers"
              :key="user.UserID"
              class="child row user hoverable"
              :class="{ selected: user.UserID === selectedUser.UserID }"
              @click="selectedUser = user"
            >
              <span class="name">{{ user.LastName }}, {{ user.FirstName }}</span>
              <span class="user-id">{{ user.UserID }}</span>
            </li>
          </ul>
        </div>
      </template>
      <template v-if="selectedType === 'group'">
        <div class="single-group">Groups</div>
        <div class="master-list">
          <ul>
            <li
              v-for="role in roles"
              :key="role.RoleName"
              class="child hoverable"
              :class="{ selected: role.RoleName === selectedRole.RoleName }"
              @click="selectedRole = role"
            >
              <span>{{ role.RoleName }}</span>
            </li>
          </ul>
        </div>
      </template>
    </div>

    <div class="column">
      <input
        v-model="filterText"
        placeholder="Filter Users"
        class="text-input"
      />
      <div
        v-if="selectedUser"
        id="current"
      >
        <b v-if="selectedType === 'user' && selectedUser.LastName && selectedUser.FirstName">
          Group memberships of: {{ selectedUser.LastName }}, {{ selectedUser.FirstName }}
        </b>
        <b v-else-if="selectedType === 'group'">Adding users to: {{ selectedRole.RoleName }}</b>
      </div>

      <div class="master-list">
        <ul v-if="selectedType === 'user'">
          <li
            v-for="(access, i) in groupsForUser"
            :key="i"
            class="child row"
          >
            <div class="check-container">
              <input
                v-model="access.IsEnabled"
                type="checkbox"
                @click="changeRole($event, access)"
              />
              <span>{{ access.RoleName }}</span>
            </div>
          </li>
        </ul>

        <ul v-if="selectedType === 'group'">
          <li
            v-for="(access, i) in usersForGroup"
            :key="i"
            class="child row user"
          >
            <div class="check-container">
              <input
                v-model="access.IsEnabled"
                type="checkbox"
                @click="changeRole($event, access)"
              />
              <span class="name">{{ access.LastName }}, {{ access.FirstName }}</span>
            </div>
            <span class="user-id">{{ access.UserID }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Enumerable from 'linq';

import Multitoggle from '@baseball-systems/MultiToggle';

import { notificationsMixin } from 'library/mixins/notifications';
import { httpMixin } from 'library/mixins/http';

export default {
  components: {
    multitoggle: Multitoggle,
  },
  mixins: [notificationsMixin, httpMixin],
  data() {
    return {
      users: [],
      roles: [],
      access: [],
      selectedUser: null,
      selectedRole: null,
      filterText: '',
      selectedType: 'user',
      byOptions: [
        {
          val: 'user',
          label: 'By User',
        },
        {
          val: 'group',
          label: 'By Group',
        },
      ],
    };
  },
  computed: {
    filteredUsers: function () {
      if (this.filterText.length === 0) {
        return this.users;
      } else {
        return this.users.filter((u) => {
          let ft = this.filterText.toLowerCase();
          return u.UserID.toLowerCase().includes(ft) || (u.FirstName && u.FirstName.toLowerCase().includes(ft));
        });
      }
    },
    groupsForUser: function () {
      if (!this.selectedUser) return;

      return Enumerable.from(this.access)
        .where(`x => x.UserID === '${this.selectedUser.UserID}'`)
        .orderBy('$.RoleName')
        .toArray();
    },
    usersForGroup: function () {
      const filterText = this.filterText.toLowerCase();
      if (!this.selectedRole) return;
      return Enumerable.from(this.access)
        .where(`x => x.RoleName === '${this.selectedRole.RoleName}'`)
        .where(
          `x => x.UserID.toLowerCase().includes('${filterText}') || (x.FirstName  !== null && x.FirstName.toLowerCase().includes('${filterText}'))`,
        )
        .orderBy('$.LastName')
        .toArray();
    },
  },

  created() {
    this.request('/dvsvc/SecUserRoles').then((resp) => {
      if (resp.IsError) {
        this.notifyDanger('Error: SecUserRoles service');
        return;
      }
      this.users = Enumerable.from(resp.Users).orderBy('$.LastName').toArray();
      this.roles = resp.Roles;
      this.access = resp.Access;

      this.selectedUser = this.users[0];
      this.selectedRole = this.roles[0];
    });
  },
  methods: {
    changeRole: function (_e, _access) {
      _access.IsEnabled = !_access.IsEnabled;
      this.request('/dvsvc/SecUserRolesAccess', 'POST', _access).then((resp) => {
        if (resp.IsError) {
          this.notifyDanger('Error: SecUserRolesAccess service');
          return;
        }
        this.notifySuccess('User Role Updated');
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
